import { render, staticRenderFns } from "./InfoColorIcon.vue?vue&type=template&id=e188aaa2&"
import script from "./InfoColorIcon.vue?vue&type=script&lang=js&"
export * from "./InfoColorIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports